<app-base-modal
  [title]="`Создать ${qualityControlResourceType.name}`"
>
  @if (isLoading) {
    <app-loader/>
  } @else {
    <form
      class="create-quality-control"
      [formGroup]="createQualityControlForm"
    >
      @for (field of createQualityControlFormFields; track $index) {
        @switch (field.type) {
          @case ('select') {
            @if (getOptionsByKey(field.fieldName).length > 0) {
              <app-custom-mat-select
                [label]="field.label"
                [options]="getOptionsByKey(field.fieldName)"
                [needEmptyValue]="false"
                [fullWidth]="true"
                (selectedChange)="handleSelectChange($event, field.fieldName)"
              />
            }
          }
        }
      }
    </form>
  }

  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      class="save-button"
      type="button"
      [disabled]="createQualityControlForm.invalid"
      (click)="handleCreateQualityControl()"
    >
      Создать
    </button>
    <button
      mat-button
      color="warn"
      class="mat-button"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
  </div>
</app-base-modal>
